import React from 'react';
import './App.css';
import { useIframeSizer } from "./lib/iframe";
import { Main } from "./Main";

function App() {
  useIframeSizer()
  return <Main/>
}

export default App;
